import { createStore } from "vuex";

import modules from "./modules";

const store = createStore({
  modules,
  // Enable strict mode in development to get a warning
  // when mutating state outside of a mutation.
  // https://vuex.vuejs.org/guide/strict.html
  strict: process.env.NODE_ENV !== "production",
  state: {
    mediaUrl:
      process.env.NODE_ENV === "development"
        ? "http://localhost:5009/"
        : "https://kswc.smart-node.net/api",
  },
});

export default store;
